import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.string.link";
import "core-js/modules/es6.function.name";
import _defineProperty from "/Users/yangwei/work/project/cat_help_admin/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.map";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getPage as _getPage, getMaterialVideo } from '@/api/wxmp/wxmaterial';
import { mapGetters } from 'vuex';
import WxNews from '@/components/wx-news/main.vue';
import WxMaterialSelect from '@/components/wx-material-select/main.vue';
import WxVoicePlayer from '@/components/wx-voice-play/main.vue';
import store from "@/store";
import { getStore } from '@/util/store';
export default {
  name: "wxReplySelect",
  components: {
    WxNews: WxNews,
    WxMaterialSelect: WxMaterialSelect,
    WxVoicePlayer: WxVoicePlayer
  },
  props: {
    appId: {
      type: String
    },
    objData: {
      type: Object
    },
    oneNews: {
      type: Boolean,
      default: false
    },
    //图文类型：1、已发布图文；2、草稿箱图文
    newsType: {
      type: String,
      default: "1"
    }
  },
  data: function data() {
    return {
      tempPlayerObj: {
        type: '2'
      },
      tableData: [],
      page: {
        total: 0,
        // 总页数
        currentPage: 1,
        // 当前页数
        pageSize: 20,
        // 每页显示多少条
        ascs: [],
        //升序字段
        descs: [] //降序字段
      },

      tableLoading: false,
      dialogNewsVisible: false,
      dialogImageVisible: false,
      dialogVoiceVisible: false,
      dialogVideoVisible: false,
      dialogThumbVisible: false,
      tempObj: new Map().set(this.objData.repType, Object.assign({}, this.objData)),
      fileList: [],
      uploadData: {
        "appId": this.appId,
        "mediaType": this.objData.repType,
        "title": '',
        "introduction": ''
      },
      actionUrl: '/weixin/wxmaterial/materialFileUpload',
      headers: {
        Authorization: 'Bearer ' + store.getters.access_token
      }
    };
  },
  created: function created() {
    if (this.userInfo.type == '-1') {
      var switchTenantId = getStore({
        name: 'switchTenantId'
      });
      if (switchTenantId) {
        this.headers['switch-tenant-id'] = switchTenantId;
      }
    }
  },
  computed: _objectSpread({}, mapGetters(['permissions', 'userInfo'])),
  methods: {
    beforeThumbImageUpload: function beforeThumbImageUpload(file) {
      var isType = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/gif' || file.type === 'image/bmp' || file.type === 'image/jpg';
      var isLt = file.size / 1024 / 1024 < 2;
      if (!isType) {
        this.$message.error('上传图片格式不对!');
      }
      if (!isLt) {
        this.$message.error('上传图片大小不能超过2M!');
      }
      return isType && isLt;
    },
    deleteObj: function deleteObj() {
      this.$delete(this.objData, 'repName');
      this.$delete(this.objData, 'repUrl');
      this.$delete(this.objData, 'content');
    },
    beforeVoiceUpload: function beforeVoiceUpload(file) {
      this.tableLoading = true;
      var isType = file.type === 'audio/mp3' || file.type === 'audio/wma' || file.type === 'audio/wav' || file.type === 'audio/amr';
      var isLt = file.size / 1024 / 1024 < 2;
      if (!isType) {
        this.$message.error('上传语音格式不对!');
      }
      if (!isLt) {
        this.$message.error('上传语音大小不能超过2M!');
      }
      return isType && isLt;
    },
    beforeImageUpload: function beforeImageUpload(file) {
      var isType = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/gif' || file.type === 'image/bmp' || file.type === 'image/jpg';
      var isLt = file.size / 1024 / 1024 < 2;
      if (!isType) {
        this.$message.error('上传图片格式不对!');
      }
      if (!isLt) {
        this.$message.error('上传图片大小不能超过2M!');
      }
      return isType && isLt;
    },
    handleUploadSuccess: function handleUploadSuccess(response, file, fileList) {
      if (response.code == '0') {
        this.fileList = [];
        this.uploadData.title = '';
        this.uploadData.introduction = '';
        var item = response.data;
        this.selectMaterial(item);
      } else {
        this.$message.error('上传出错：' + response.msg);
      }
    },
    handleClick: function handleClick(tab, event) {
      this.uploadData.mediaType = this.objData.repType;
      var tempObjItem = this.tempObj.get(this.objData.repType);
      if (tempObjItem) {
        this.objData.repName = tempObjItem.repName ? tempObjItem.repName : null;
        this.objData.repMediaId = tempObjItem.repMediaId ? tempObjItem.repMediaId : null;
        this.objData.media_id = tempObjItem.media_id ? tempObjItem.media_id : null;
        this.objData.repUrl = tempObjItem.repUrl ? tempObjItem.repUrl : null;
        this.objData.content = tempObjItem.content ? tempObjItem.content : null;
        this.objData.repDesc = tempObjItem.repDesc ? tempObjItem.repDesc : null;
      } else {
        this.$delete(this.objData, 'repName');
        this.$delete(this.objData, 'repMediaId');
        this.$delete(this.objData, 'media_id');
        this.$delete(this.objData, 'repUrl');
        this.$delete(this.objData, 'content');
        this.$delete(this.objData, 'repDesc');
      }
    },
    selectMaterial: function selectMaterial(item) {
      var _this = this;
      var tempObjItem = {};
      tempObjItem.repType = this.objData.repType;
      tempObjItem.repMediaId = item.mediaId;
      tempObjItem.media_id = item.mediaId;
      tempObjItem.content = item.content;
      this.dialogNewsVisible = false;
      this.dialogImageVisible = false;
      this.dialogVoiceVisible = false;
      this.dialogVideoVisible = false;
      this.objData.repMediaId = item.mediaId;
      this.objData.media_id = item.mediaId;
      this.objData.content = item.content;
      if (this.objData.repType == 'music') {
        tempObjItem.repThumbMediaId = item.mediaId;
        tempObjItem.repThumbUrl = item.url;
        this.objData.repThumbMediaId = item.mediaId;
        this.objData.repThumbUrl = item.url;
        this.dialogThumbVisible = false;
      } else {
        tempObjItem.repName = item.name;
        tempObjItem.repUrl = item.url;
        this.objData.repName = item.name;
        this.objData.repUrl = item.url;
      }
      if (this.objData.repType == 'video') {
        getMaterialVideo({
          appId: this.appId,
          mediaId: item.mediaId
        }).then(function (response) {
          if (response.data.code == 0) {
            var data = response.data.data;
            _this.$set(_this.objData, 'repName', data.title);
            _this.$set(_this.objData, 'repDesc', data.description);
            _this.$set(_this.objData, 'repUrl', data.downUrl);
            tempObjItem.repDesc = data.description;
            tempObjItem.repUrl = data.downUrl;
          }
        });
      }
      if (this.oneNews && this.objData.repType == 'news' && item.content.articles.length > 1) {
        this.$alert('您选择的是多图文，微信限制只能回复1条图文消息，将默认选择第一篇', '提示', {
          confirmButtonText: '确定'
        });
        item.content.articles = item.content.articles.slice(0, 1);
      }
      this.tempObj.set(this.objData.repType, tempObjItem);
    },
    openMaterial: function openMaterial() {
      if (this.objData.repType == 'news') {
        this.dialogNewsVisible = true;
      } else if (this.objData.repType == 'image') {
        this.dialogImageVisible = true;
      } else if (this.objData.repType == 'voice') {
        this.dialogVoiceVisible = true;
      } else if (this.objData.repType == 'video') {
        this.dialogVideoVisible = true;
      } else if (this.objData.repType == 'music') {
        this.dialogThumbVisible = true;
      }
    },
    getPage: function getPage(page, params) {
      var _this2 = this;
      this.tableLoading = true;
      _getPage(Object.assign({
        current: page.currentPage,
        size: page.pageSize,
        appId: this.appId,
        type: this.objData.repType
      }, params)).then(function (response) {
        _this2.tableData = response.data.data.items;
        _this2.page.total = response.data.data.totalCount;
        _this2.page.currentPage = page.currentPage;
        _this2.page.pageSize = page.pageSize;
        _this2.tableLoading = false;
      });
    },
    sizeChange: function sizeChange(val) {
      this.page.currentPage = 1;
      this.page.pageSize = val;
      this.getPage(this.page);
    },
    handleError: function handleError(err, file, fileList) {
      this.$message.error(err + '');
    },
    handleSuccess: function handleSuccess(response, file, fileList) {
      this.$set(this.objData, 'repUrl', response.link);
    },
    handleSuccess2: function handleSuccess2(response, file, fileList) {
      this.$set(this.objData, 'repHqUrl', response.link);
    }
  }
};